import React, { Component } from "react";
import { Card, Row, Col, Typography, Modal, Space, Popconfirm, Tag, message, Spin } from "antd";
import { BookOutlined, EyeOutlined, PlusOutlined, EditOutlined, ExportOutlined } from "@ant-design/icons";
import ButtonItem from "../../../../Components/ButtonItem";
import { connect } from "react-redux";
import axios from "axios";
import AgregarManual from "./AgregarManual/AgregarManual";
import InputItem from "../../../../Components/InputItem";
import EditarManual from "./EditarManual/EditarManual";
import { SegmentedItem } from "../../../../Components/Items";
import { MANUALES_NUEVOS, urlManual, abrirManual } from "../../../../Components/manualesAyuda";

const { Title, Text } = Typography;

const EMPRESA_AUTORIZADA = "66f196f27a90444bd4d4f533";

class Manuales extends Component {
  state = {
    modalVisualizarVisible: false,
    selectedManualVisualizar: null,
    modalAgregarVisible: false,
    modalEditarVisible: false,
    selectedManualEditar: null,
    manuales: [],
    manualesFiltrados: [],
    loading: false,
    searchText: "",
    vista: "manuales"
  };

  componentDidMount() {
    if (EMPRESA_AUTORIZADA === this.props.empresaId) {
      this.cargarManualesAdmin();
    } else {
      this.cargarManuales();
    }
  }

  handleSearch = (value) => {
    const texto = value.toLowerCase();

    const filtrados = this.state.manuales.filter(m =>
      m.titulo?.toLowerCase().includes(texto) ||
      m.descripcion?.toLowerCase().includes(texto) ||
      m.categoria?.toLowerCase().includes(texto)
    );

    this.setState({
      searchText: value,
      manualesFiltrados: filtrados
    });
  };

  cargarManuales = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        "manuales/selectManuales",
        {},
        this.props.headersToken
      );

      if (response.data.success === 2) {
        this.setState({
          manuales: response.data.manuales,
          manualesFiltrados: response.data.manuales,
        });
      }
    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  cargarManualesAdmin = async () => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        "manuales/selectTodosManuales",
        {},
        this.props.headersToken
      );

      if (response.data.success === 2) {
        this.setState({
          manuales: response.data.manuales,
          manualesFiltrados: response.data.manuales,
        });
      } else {
        message.error("Error al cargar los manuales");
      }
    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };

  isEmpresaAutorizada = () => {
    return this.props.empresaId === EMPRESA_AUTORIZADA;
  };

  abrirModalVisualizarNuevo = (manual) => {
    this.setState({
      modalVisualizarVisible: true,
      selectedManualVisualizar: { ...manual, blobUrl: urlManual(manual), esNuevo: true },
    });
  };

  manualesNuevosFiltrados = () => {
    const texto = this.state.searchText.toLowerCase();
    return MANUALES_NUEVOS.filter((m) =>
      m.titulo.toLowerCase().includes(texto) ||
      m.descripcion.toLowerCase().includes(texto) ||
      m.categoria.toLowerCase().includes(texto)
    );
  };

  renderManualesNuevos = () => (
    <Row gutter={[24, 24]}>
      {this.manualesNuevosFiltrados().map((manual) => (
        <Col xs={24} sm={24} md={12} lg={8} key={manual.archivo}>
          <Card
            hoverable
            bordered={false}
            style={{ boxShadow: "0 2px 8px rgba(0,0,0,0.1)", height: "100%" }}
            bodyStyle={{ padding: 0 }}
          >
            <div
              onClick={() => this.abrirModalVisualizarNuevo(manual)}
              style={{ height: 190, overflow: "hidden", position: "relative", cursor: "pointer", borderBottom: "1px solid #f0f0f0", borderRadius: "8px 8px 0 0", background: "#fafafa" }}
            >
              <iframe
                src={urlManual(manual)}
                title={`Vista previa ${manual.titulo}`}
                loading="lazy"
                tabIndex={-1}
                style={{ width: 1200, height: 633, border: "none", transform: "scale(0.3)", transformOrigin: "top left", pointerEvents: "none" }}
              />
            </div>
            <div style={{ padding: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                <Title level={5} style={{ marginBottom: 0, flex: 1 }}>{manual.titulo}</Title>
                <Tag color="blue" style={{ marginLeft: 8 }}>{manual.categoria}</Tag>
              </div>
              <Text type="secondary" style={{ display: "block", marginBottom: 16 }}>{manual.descripcion}</Text>
              <div style={{ display: "flex", gap: 8 }}>
                <ButtonItem type="primary" icon={<EyeOutlined />} onClick={() => this.abrirModalVisualizarNuevo(manual)} style={{ flex: 1 }}>
                  Ver
                </ButtonItem>
                <ButtonItem blanco icon={<ExportOutlined />} onClick={() => abrirManual(manual)} style={{ flex: 1 }}>
                  Nueva pestaña
                </ButtonItem>
              </div>
            </div>
          </Card>
        </Col>
      ))}
    </Row>
  );

  abrirModalVisualizar = async (manual) => {
    this.setState({ loading: true });

    const blobUrl = await this.generarBlobUrl(manual);

    this.setState({
      modalVisualizarVisible: true,
      selectedManualVisualizar: {
        ...manual,
        blobUrl
      },
      loading: false
    });
  };

  cerrarModalVisualizar = () => {
    this.setState({
      modalVisualizarVisible: false,
      selectedManualVisualizar: null
    });
  };

  abrirModalAgregar = () => {
    this.setState({
      modalAgregarVisible: true
    });
  };

  cerrarModalAgregar = () => {
    this.setState({
      modalAgregarVisible: false
    });
  };

  handleManualAgregado = () => {
    this.cerrarModalAgregar();
    if (EMPRESA_AUTORIZADA === this.props.empresaId) {
      this.cargarManualesAdmin();
    } else {
      this.cargarManuales();
    }
  };

  abrirModalEditar = (manual) => {
    this.setState({
      modalEditarVisible: true,
      selectedManualEditar: manual
    });
  };

  cerrarModalEditar = () => {
    this.setState({
      modalEditarVisible: false,
      selectedManualEditar: null
    });
  };

  handleManualEditado = () => {
    this.cerrarModalEditar();
    if (EMPRESA_AUTORIZADA === this.props.empresaId) {
      this.cargarManualesAdmin();
    } else {
      this.cargarManuales();
    }
  };

  handleDeshabilitar = async (manualId) => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        'manuales/deshabilitarManual',
        { manualId },
        this.props.headersToken
      );

      if (response.data.success === 2) {
        message.success('Manual deshabilitado correctamente');
        if (EMPRESA_AUTORIZADA === this.props.empresaId) {
          this.cargarManualesAdmin();
        } else {
          this.cargarManuales();
        }
      } else {
        message.error('Error al deshabilitar el manual');
      }
    } catch (error) {
      console.error(error);
      message.error('Error al conectar con el servidor');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleHabilitar = async (manualId) => {
    this.setState({ loading: true });
    try {
      const response = await axios.post(
        'manuales/habilitarManual',
        { manualId },
        this.props.headersToken
      );

      if (response.data.success === 2) {
        message.success('Manual habilitado correctamente');
        if (EMPRESA_AUTORIZADA === this.props.empresaId) {
          this.cargarManualesAdmin();
        } else {
          this.cargarManuales();
        }
      } else {
        message.error('Error al habilitar el manual');
      }
    } catch (error) {
      console.error(error);
      message.error('Error al conectar con el servidor');
    } finally {
      this.setState({ loading: false });
    }
  };

  handleDownload = async (manual) => {
    try {
      const response = await fetch(manual.pdfUrl);

      if (!response.ok) {
        message.error("No se pudo descargar el archivo");
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${manual.titulo || "manual"}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      message.success("Descarga iniciada");
    } catch (error) {
      console.error(error);
      message.error("Error al descargar el archivo");
    }
  };

  generarBlobUrl = async (manual) => {
    try {
      const response = await fetch(manual.pdfUrl);

      if (!response.ok) {
        message.error("No se pudo cargar el PDF");
        return null;
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      return blobUrl;

    } catch (error) {
      console.error(error);
      message.error("Error cargando el PDF");
      return null;
    }
  };

  render() {
    const {
      modalVisualizarVisible,
      selectedManualVisualizar,
      modalAgregarVisible,
      modalEditarVisible,
      selectedManualEditar
    } = this.state;
    const { headersToken, empresaId } = this.props;
    const isAutorizada = this.isEmpresaAutorizada();
    return (
      <>
        <Spin spinning={this.state.loading} size="large">
          <div style={{ padding: '20px 0' }}>
            <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <Title level={3}>
                  <BookOutlined style={{ marginRight: 8 }} />
                  Manuales de Usuario
                </Title>
                <Text type="secondary">
                  Descarga o visualiza nuestros manuales en formato PDF
                </Text>
              </div>
              {isAutorizada && (
                <ButtonItem
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={this.abrirModalAgregar}
                >
                  Agregar Manual
                </ButtonItem>
              )}
            </div>

            <div style={{ marginBottom: 20, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
              <SegmentedItem
                options={[{ label: "Manuales", value: "manuales" }, { label: "Manuales nuevos", value: "nuevos" }]}
                value={this.state.vista}
                onChange={(vista) => this.setState({ vista })}
              />
            </div>

            <div style={{ marginBottom: 20, maxWidth: 350 }}>
              <InputItem
                placeholder="Buscar manual..."
                value={this.state.searchText}
                onChange={(e) => this.handleSearch(e.target.value)}
              />
            </div>

            {this.state.vista === "nuevos" ? this.renderManualesNuevos() : <Row gutter={[24, 24]}>
              {this.state.manualesFiltrados.map((manual) => (
                <Col xs={24} sm={24} md={12} lg={8} key={manual._id}>
                  <Card
                    hoverable
                    bordered={false}
                    className="pdf-preview-card"
                    style={{
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                      height: '100%'
                    }}
                  >

                    {/* Resto del contenido de la card igual */}
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                        <Title level={5} style={{ marginBottom: 0, flex: 1 }}>
                          {manual.titulo}
                        </Title>
                        {manual.categoria && (
                          <Tag color="blue" style={{ marginLeft: 8 }}>{manual.categoria}</Tag>
                        )}
                      </div>
                      <Text type="secondary" style={{ display: 'block', marginBottom: 12 }}>
                        {manual.descripcion}
                      </Text>
                      {manual.paginas && (
                        <div style={{ marginBottom: 16 }}>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            <BookOutlined style={{ marginRight: 4 }} />
                            {manual.paginas}
                          </Text>
                        </div>
                      )}

                      <Space style={{ width: '100%' }} direction="vertical">
                        <div style={{ display: 'flex', gap: 8 }}>
                          <ButtonItem
                            type="primary"
                            icon={<EyeOutlined />}
                            onClick={() => this.abrirModalVisualizar(manual)}
                            style={{ flex: 1 }}
                          >
                            Ver
                          </ButtonItem>

                          {/* <ButtonItem
                            icon={<DownloadOutlined />}
                            onClick={() => this.handleDownload(manual)}
                            style={{ flex: 1 }}
                            blanco
                          >
                            Descargar
                          </ButtonItem> */}
                        </div>

                        {isAutorizada && (
                          <div style={{ display: 'flex', gap: 8 }}>
                            <ButtonItem
                              icon={<EditOutlined />}
                              onClick={() => this.abrirModalEditar(manual)}
                              style={{ flex: 1 }}
                            >
                              Editar
                            </ButtonItem>
                            <Popconfirm
                              title={`¿Estás seguro de ${manual.estado === 1 ? 'deshabilitar' : 'habilitar'} este manual?`}
                              onConfirm={() => manual.estado === 1 ? this.handleDeshabilitar(manual._id) : this.handleHabilitar(manual._id)}
                              okText="Sí"
                              cancelText="No"
                            >
                              {manual.estado === 1 ? (
                                <ButtonItem
                                  danger
                                  style={{ flex: 1 }}
                                >
                                  Deshabilitar
                                </ButtonItem>
                              ) : (
                                <ButtonItem
                                  type="primary"
                                  style={{ flex: 1 }}
                                  verde
                                >
                                  Habilitar
                                </ButtonItem>
                              )}
                            </Popconfirm>
                          </div>
                        )}
                      </Space>
                    </div>
                  </Card>
                </Col>
              ))}
            </Row>}


            <Modal
              title={selectedManualVisualizar?.titulo}
              visible={modalVisualizarVisible}
              onCancel={this.cerrarModalVisualizar}
              width={selectedManualVisualizar?.esNuevo ? "80%" : "50%"}
              style={{ top: 20 }}
              footer={[
                // <ButtonItem
                //   key="download"
                //   icon={<DownloadOutlined />}
                //   onClick={() => this.handleDownload(selectedManualVisualizar)}
                // >
                //   Descargar
                // </ButtonItem>,
                <ButtonItem
                  key="close"
                  type="primary"
                  onClick={this.cerrarModalVisualizar}
                >
                  Cerrar
                </ButtonItem>
              ]}
            >
              {selectedManualVisualizar && (
                <div style={{ height: "78vh" }}>
                  <iframe
                    src={selectedManualVisualizar.esNuevo ? selectedManualVisualizar.blobUrl : `${selectedManualVisualizar.blobUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none"
                    }}
                    title={selectedManualVisualizar.titulo}
                  />
                </div>
              )}
            </Modal>

            <AgregarManual
              visible={modalAgregarVisible}
              onCancel={this.cerrarModalAgregar}
              onSuccess={this.handleManualAgregado}
              headersToken={headersToken}
              empresaId={empresaId}
            />

            <EditarManual
              key={selectedManualEditar?._id}
              visible={modalEditarVisible}
              manual={selectedManualEditar}
              empresaId={empresaId}
              headersToken={headersToken}
              onSuccess={this.handleManualEditado}
              onCancel={this.cerrarModalEditar}
            />
          </div>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(Manuales);
